import { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useHistory } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";
import SelectorCiudad from "../custom/SelectorCiudad";
import SelectorPais from "../custom/SelectorPais";
import SelectorTipoDocumento from "../custom/SelectorTipoDocumento";
import SelectorZona from "../custom/SelectorZona";
import CampoNit from "../custom/CampoNit";
import ModalOdontogramaLaboratorio from "./ModalOdontogramaLaboratorio";
import { Modal, Button } from "react-bootstrap";

function CrearOrdenLaboratorio() {
    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [loading, setLoading] = useState(false);

    // Datos de la orden
    const [empresaId, setEmpresaId] = useState(''); // ID de la empresa que encarga
    const [empresaNombre, setEmpresaNombre] = useState(''); // Nombre de la empresa
    const [empresaDocumento, setEmpresaDocumento] = useState(''); // Documento de la empresa
    const [pacienteNombre, setPacienteNombre] = useState(''); // Nombre del paciente final (texto libre)
    const [pacienteDocumento, setPacienteDocumento] = useState(''); // Documento del paciente final (texto libre)
    const [fechaRecepcion, setFechaRecepcion] = useState(new Date().toISOString().split('T')[0]);
    const [fechaEntrega, setFechaEntrega] = useState('');
    const [horaEntrega, setHoraEntrega] = useState('');
    const [observaciones, setObservaciones] = useState('');

    // Catálogos
    const [tiposTrabajo, setTiposTrabajo] = useState([]);
    const [materiales, setMateriales] = useState([]);
    const [profesionales, setProfesionales] = useState([]);

    // Detalles de trabajos
    const [trabajos, setTrabajos] = useState([]);

    // Modal empresa
    const [showModalEmpresa, setShowModalEmpresa] = useState(false);
    const [empresas, setEmpresas] = useState([]);
    const [busquedaEmpresa, setBusquedaEmpresa] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const empresasPorPagina = 10;

    // Modal Odontograma
    const [showModalOdontograma, setShowModalOdontograma] = useState(false);
    const [odontogramaData, setOdontogramaData] = useState(null);

    // Modal crear empresa
    const [showModalCrearEmpresa, setShowModalCrearEmpresa] = useState(false);
    const [nombreEmpresa, setNombreEmpresa] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [digitoVerificacion, setDigitoVerificacion] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [direccion, setDireccion] = useState('');
    const [ciudadResidencia, setCiudadResidencia] = useState(null);
    const [paisResidencia, setPaisResidencia] = useState('');
    const [zona, setZona] = useState('');
    const [telefono, setTelefono] = useState('');
    const [celular, setCelular] = useState('');
    const [email, setEmail] = useState('');
    const [loadingEmpresa, setLoadingEmpresa] = useState(false);
    const [errorlistEmpresa, setErrorlistEmpresa] = useState({});

    // Modal de confirmación
    const [showModalConfirmacion, setShowModalConfirmacion] = useState(false);
    const [mensajeModal, setMensajeModal] = useState('');
    const [ordenIdCreada, setOrdenIdCreada] = useState(null);

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS
        let tienePermiso = false;

        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'gestionLaboratorio');
        } else if (userdata.up && userdata.up.includes('gestionLaboratorio')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        // Cargar datos iniciales
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => console.log('err: ' + error));

        // Cargar catálogos
        axios.get('/catalogos-laboratorio?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setTiposTrabajo(response.data.tipos_trabajo || []);
                    setMateriales(response.data.materiales || []);
                }
            })
            .catch(error => console.log('err: ' + error));

        // Cargar profesionales - Usar endpoint optimizado que solo trae id, name, lastname
        axios.get('/usuarios-basico')
            .then(response => {
                if (response.status === 200) {
                    setProfesionales(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando profesionales: ' + error);
            });

        // Cargar empresas (tipo_cliente=1)
        const params = {
            uid: userdata.user_id,
            solo_empresas: true // Filtrar solo empresas
        };
        axios.get('/pacientes', { params })
            .then(response => {
                if (response.status === 200) setEmpresas(response.data);
            })
            .catch(error => console.log('err: ' + error));

    }, []);

    const handleShowModalConfirmacion = () => setShowModalConfirmacion(true);
    const handleCloseModalConfirmacion = () => setShowModalConfirmacion(false);
    const handleVerDetalle = () => {
        history.push(`/detalle-orden-laboratorio/${ordenIdCreada}`);
    };

    const agregarTrabajo = () => {
        const nuevoTrabajo = {
            id: Date.now(),
            tipo_trabajo_id: '',
            material_id: '',
            diente: '',
            color: '',
            profesional_asignado_id: '',
            observaciones: ''
        };
        setTrabajos([...trabajos, nuevoTrabajo]);
    };

    const eliminarTrabajo = (id) => {
        setTrabajos(trabajos.filter(t => t.id !== id));
    };

    const actualizarTrabajo = (id, campo, valor) => {
        setTrabajos(trabajos.map(t => {
            if (t.id === id) {
                return { ...t, [campo]: valor };
            }
            return t;
        }));
    };

    const handleSaveOdontograma = (data) => {
        setOdontogramaData(data);
    };

    const getEmpresasFiltradas = () => {
        if (!busquedaEmpresa) return empresas;
        return empresas.filter(empresa => {
            const nombre = (empresa.primer_nombre || '').toLowerCase();
            const documento = empresa.numero_documento || '';
            const busqueda = busquedaEmpresa.toLowerCase();
            return nombre.includes(busqueda) || documento.includes(busqueda);
        });
    };

    const getEmpresasPaginadas = () => {
        const empresasFiltradas = getEmpresasFiltradas();
        const inicio = (paginaActual - 1) * empresasPorPagina;
        const fin = inicio + empresasPorPagina;
        return empresasFiltradas.slice(inicio, fin);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getEmpresasFiltradas().length / empresasPorPagina);
    };

    const seleccionarEmpresa = (empresa) => {
        setEmpresaId(empresa.id);
        setEmpresaNombre(empresa.primer_nombre || '');
        setEmpresaDocumento(empresa.numero_documento || '');
        setShowModalEmpresa(false);
    };

    const handleNitChange = (nit, dv) => {
        setNumeroDocumento(nit);
        setDigitoVerificacion(dv);
    };

    const limpiarFormularioEmpresa = () => {
        setNombreEmpresa('');
        setTipoDocumento('');
        setNumeroDocumento('');
        setDigitoVerificacion('');
        setDescripcion('');
        setDireccion('');
        setCiudadResidencia(null);
        setPaisResidencia('');
        setZona('');
        setTelefono('');
        setCelular('');
        setEmail('');
        setErrorlistEmpresa({});
    };

    const abrirModalCrearEmpresa = () => {
        limpiarFormularioEmpresa();
        setShowModalEmpresa(false);
        setShowModalCrearEmpresa(true);
    };

    const handleSubmitEmpresa = async (e) => {
        e.preventDefault();

        // Validaciones del lado del cliente
        const errores = {};

        if (!nombreEmpresa.trim()) {
            errores.primer_nombre = ['El nombre de la empresa es obligatorio'];
        }

        if (!tipoDocumento) {
            errores.tipo_documento = ['El tipo de documento es obligatorio'];
        }

        if (!numeroDocumento.trim()) {
            errores.numero_documento = ['El número de documento es obligatorio'];
        }

        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            errores.email = ['El formato del email no es válido'];
        }

        if (Object.keys(errores).length > 0) {
            setErrorlistEmpresa(errores);
            return;
        }

        setLoadingEmpresa(true);
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        const data = {
            primer_nombre: nombreEmpresa,
            tipo_documento: tipoDocumento,
            numero_documento: numeroDocumento,
            dv: digitoVerificacion ? String(digitoVerificacion) : null,
            nombre_ocupacion: descripcion,
            direccion: direccion,
            ciudad: ciudadResidencia,
            pais_residencia: paisResidencia,
            zona: zona,
            telefono: telefono,
            celular: celular,
            email: email
        };

        try {
            const response = await axios.post('/empresa', data);
            if (response.status === 200 || response.status === 201) {
                // Agregar la nueva empresa a la lista
                const nuevaEmpresa = response.data.empresa || response.data;
                setEmpresas([...empresas, nuevaEmpresa]);

                // Seleccionar automáticamente la empresa recién creada
                setEmpresaId(nuevaEmpresa.id);
                setEmpresaNombre(nuevaEmpresa.primer_nombre || '');
                setEmpresaDocumento(nuevaEmpresa.numero_documento || '');

                // Cerrar modal y limpiar
                setShowModalCrearEmpresa(false);
                limpiarFormularioEmpresa();
                alert('Empresa creada exitosamente');
            }
        } catch (error) {
            setLoadingEmpresa(false);
            if (error.response && error.response.data && error.response.data.errors) {
                setErrorlistEmpresa(error.response.data.errors);
            } else if (error.response && error.response.data && error.response.data.message) {
                alert('Error: ' + error.response.data.message);
            } else {
                console.error('Error creando empresa:', error);
                alert('Error al crear la empresa');
            }
        } finally {
            setLoadingEmpresa(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!empresaId) {
            alert('Por favor seleccione una empresa');
            return;
        }

        if (!pacienteNombre.trim()) {
            alert('Por favor ingrese el nombre del paciente final');
            return;
        }

        if (!pacienteDocumento.trim()) {
            alert('Por favor ingrese el documento del paciente final');
            return;
        }

        if (trabajos.length === 0) {
            alert('Debe agregar al menos un trabajo');
            return;
        }

        // Validar que todos los trabajos tengan los campos requeridos
        for (let trabajo of trabajos) {
            if (!trabajo.tipo_trabajo_id || !trabajo.material_id || !trabajo.diente || !trabajo.profesional_asignado_id) {
                alert('Todos los trabajos deben tener tipo, material, diente y profesional asignado');
                return;
            }
        }

        setLoading(true);
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        const ordenData = {
            uid: userdata.user_id,
            paciente_id: parseInt(empresaId), // ID de la empresa que encarga
            paciente_nombre: pacienteNombre, // Nombre del paciente final (texto libre)
            paciente_documento: pacienteDocumento, // Documento del paciente final (texto libre)
            fecha_recepcion: fechaRecepcion,
            fecha_estimada_entrega: fechaEntrega,
            hora_estimada_entrega: horaEntrega || null,
            observaciones: observaciones || '',
            detalles: trabajos.map(trabajo => ({
                tipo_trabajo_id: parseInt(trabajo.tipo_trabajo_id),
                material_id: parseInt(trabajo.material_id),
                diente: trabajo.diente,
                color: trabajo.color || null,
                profesional_asignado_id: parseInt(trabajo.profesional_asignado_id),
                observaciones: trabajo.observaciones || null
            })),
            odontograma_datos: odontogramaData && Object.keys(odontogramaData).length > 0 ? JSON.stringify(odontogramaData) : null
        };

        try {
            const response = await axios.post('/orden-laboratorio', ordenData);
            if (response.status === 200 || response.status === 201) {
                // Guardar el ID de la orden creada
                setOrdenIdCreada(response.data.orden_id);
                
                // Configurar mensaje del modal
                setMensajeModal(`Orden creada exitosamente: ${response.data.numero_orden}. ¿Desea ver el detalle de la orden?`);

                // Limpiar formulario
                setEmpresaId('');
                setEmpresaNombre('');
                setEmpresaDocumento('');
                setPacienteNombre('');
                setPacienteDocumento('');
                setTrabajos([]);
                setObservaciones('');
                setFechaEntrega('');
                setHoraEntrega('');
                setOdontogramaData(null);

                // Mostrar modal después de un breve delay
                setTimeout(() => { handleShowModalConfirmacion() }, 500);
            }
        } catch (error) {
            console.error('Error completo:', error);
            alert('Error al crear la orden: ' + (error.response?.data?.message || error.message));
        } finally {
            setLoading(false);
        }
    };

    // 🔒 PROTECCIÓN DE RUTA
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn) {
        return <Loading />;
    }

    return (
        <div className="hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="laboratory" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/menu-laboratorio">Laboratorio</Link></li>
                                    <li className="breadcrumb-item">Nueva Orden</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Nueva Orden de Laboratorio</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="card card-info card-outline">
                            <div className="card-header">
                                <h5><b>Información de la Orden</b></h5>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>

                                    <h5><b>Información de la Empresa</b></h5>
                                    <p className="text-muted small">Empresa o profesional independiente que encarga la orden</p>

                                    <div className="row">
                                        <div className="col-md-5">
                                            <div className="form-group">
                                                <label>Nombre de la Empresa *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={empresaNombre}
                                                    readOnly
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>N° Documento *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={empresaDocumento}
                                                    readOnly
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>&nbsp;</label>
                                                <button
                                                    type="button"
                                                    className="btn btn-info form-control"
                                                    onClick={() => setShowModalEmpresa(true)}
                                                >
                                                    <i className="fas fa-search"></i> Buscar
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>&nbsp;</label>
                                                <button
                                                    type="button"
                                                    className="btn btn-success form-control"
                                                    onClick={abrirModalCrearEmpresa}
                                                >
                                                    <i className="fas fa-plus"></i> Nueva
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <hr />

                                    <h5><b>Información del Paciente Final</b></h5>
                                    <p className="text-muted small">Paciente de la empresa (información de referencia)</p>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Nombre del Paciente *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={pacienteNombre}
                                                    onChange={(e) => setPacienteNombre(e.target.value)}
                                                    placeholder="Nombre completo del paciente"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>N° Documento del Paciente *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={pacienteDocumento}
                                                    onChange={(e) => setPacienteDocumento(e.target.value)}
                                                    placeholder="Documento de identidad"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <hr />

                                    <h5><b>Datos de la Orden</b></h5>

                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Fecha Recepción *</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={fechaRecepcion}
                                                    onChange={(e) => setFechaRecepcion(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Fecha Estimada Entrega *</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={fechaEntrega}
                                                    onChange={(e) => setFechaEntrega(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Hora Entrega</label>
                                                <input
                                                    type="time"
                                                    className="form-control"
                                                    value={horaEntrega}
                                                    onChange={(e) => setHoraEntrega(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <hr />

                                    <h5><b>Trabajos a Realizar</b></h5>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <button
                                                type="button"
                                                className="btn btn-info mb-3"
                                                onClick={agregarTrabajo}
                                            >
                                                <i className="fas fa-plus"></i> Agregar Trabajo
                                            </button>
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Tipo de Trabajo *</th>
                                                    <th>Material *</th>
                                                    <th>Diente *</th>
                                                    <th>Color</th>
                                                    <th>Profesional *</th>
                                                    <th>Observaciones</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {trabajos.map(trabajo => (
                                                    <tr key={trabajo.id}>
                                                        <td>
                                                            <select
                                                                className="form-control form-control-sm"
                                                                value={trabajo.tipo_trabajo_id}
                                                                onChange={(e) => actualizarTrabajo(trabajo.id, 'tipo_trabajo_id', e.target.value)}
                                                                required
                                                            >
                                                                <option value="">Seleccionar...</option>
                                                                {tiposTrabajo.map(tipo => (
                                                                    <option key={tipo.id} value={tipo.id}>{tipo.nombre}</option>
                                                                ))}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <select
                                                                className="form-control form-control-sm"
                                                                value={trabajo.material_id}
                                                                onChange={(e) => actualizarTrabajo(trabajo.id, 'material_id', e.target.value)}
                                                                required
                                                            >
                                                                <option value="">Seleccionar...</option>
                                                                {materiales.map(material => (
                                                                    <option key={material.id} value={material.id}>{material.nombre}</option>
                                                                ))}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={trabajo.diente}
                                                                onChange={(e) => actualizarTrabajo(trabajo.id, 'diente', e.target.value)}
                                                                placeholder="Ej: 11, 21-22"
                                                                required
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={trabajo.color}
                                                                onChange={(e) => actualizarTrabajo(trabajo.id, 'color', e.target.value)}
                                                                placeholder="Ej: A2"
                                                            />
                                                        </td>
                                                        <td>
                                                            <select
                                                                className="form-control form-control-sm"
                                                                value={trabajo.profesional_asignado_id}
                                                                onChange={(e) => actualizarTrabajo(trabajo.id, 'profesional_asignado_id', e.target.value)}
                                                                required
                                                            >
                                                                <option value="">Seleccionar...</option>
                                                                {profesionales.map(prof => (
                                                                    <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                                ))}
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={trabajo.observaciones}
                                                                onChange={(e) => actualizarTrabajo(trabajo.id, 'observaciones', e.target.value)}
                                                                placeholder="Observaciones..."
                                                            />
                                                        </td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() => eliminarTrabajo(trabajo.id)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <hr />

                                    <div className="form-group">
                                        <label>Observaciones Generales</label>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            value={observaciones}
                                            onChange={(e) => setObservaciones(e.target.value)}
                                            placeholder="Observaciones de la orden..."
                                        ></textarea>
                                    </div>

                                    <hr />

                                    <h5><b>Información Adicional</b></h5>
                                    <div className="row mb-4">
                                        <div className="col-md-12">
                                            <button
                                                type="button"
                                                className={`btn ${odontogramaData && Object.keys(odontogramaData).length > 0 ? 'btn-success' : 'btn-outline-info'}`}
                                                onClick={() => setShowModalOdontograma(true)}
                                            >
                                                <i className={`fas ${odontogramaData && Object.keys(odontogramaData).length > 0 ? 'fa-check-circle' : 'fa-tooth'} mr-2`}></i>
                                                {odontogramaData && Object.keys(odontogramaData).length > 0
                                                    ? 'Odontograma Adjunto (Click para editar)'
                                                    : 'Crear Odontograma '}
                                            </button>
                                            {odontogramaData && Object.keys(odontogramaData).length > 0 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger ml-2"
                                                    onClick={() => {
                                                        if (window.confirm('¿Desea eliminar el odontograma adjunto?')) {
                                                            setOdontogramaData(null);
                                                        }
                                                    }}
                                                >
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <button type="submit" className="btn btn-info mr-2" disabled={loading}>
                                            <i className="fas fa-save"></i> Guardar Orden
                                            {loading && <span className="spinner-border spinner-border-sm ml-2"></span>}
                                        </button>
                                        <Link to="/listado-ordenes-laboratorio" className="btn btn-secondary">
                                            <i className="fas fa-arrow-left"></i> Cancelar
                                        </Link>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* Modal Odontograma Laboratorio */}
            <ModalOdontogramaLaboratorio
                show={showModalOdontograma}
                onHide={() => setShowModalOdontograma(false)}
                initialData={odontogramaData}
                onSave={handleSaveOdontograma}
            />

            {/* Modal Seleccionar Empresa */}
            {showModalEmpresa && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header bg-info">
                                <h5 className="modal-title">Seleccionar Empresa</h5>
                                <button type="button" className="close" onClick={() => setShowModalEmpresa(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Buscar por nombre o documento..."
                                        value={busquedaEmpresa}
                                        onChange={(e) => {
                                            setBusquedaEmpresa(e.target.value);
                                            setPaginaActual(1);
                                        }}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Documento</th>
                                                <th>Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {getEmpresasPaginadas().map((empresa, index) => (
                                                <tr key={index}>
                                                    <td>{empresa.primer_nombre}</td>
                                                    <td>{empresa.numero_documento}</td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-primary"
                                                            onClick={() => seleccionarEmpresa(empresa)}
                                                        >
                                                            Seleccionar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {getTotalPaginas() > 1 && (
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            disabled={paginaActual === 1}
                                            onClick={() => setPaginaActual(paginaActual - 1)}
                                        >
                                            Anterior
                                        </button>
                                        <span>Página {paginaActual} de {getTotalPaginas()}</span>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            disabled={paginaActual === getTotalPaginas()}
                                            onClick={() => setPaginaActual(paginaActual + 1)}
                                        >
                                            Siguiente
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-info" onClick={abrirModalCrearEmpresa}>
                                    <i className="fas fa-plus"></i> Nueva Empresa
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalEmpresa(false)}>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Crear Empresa */}
            {showModalCrearEmpresa && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header bg-info">
                                <h5 className="modal-title">
                                    <i className="fas fa-building mr-2"></i>
                                    Crear Nueva Empresa
                                </h5>
                                <button type="button" className="close" onClick={() => setShowModalCrearEmpresa(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <form onSubmit={handleSubmitEmpresa} autoComplete="off">
                                <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>

                                    {Object.keys(errorlistEmpresa).length > 0 && (
                                        <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                            <ul className="mb-0">
                                                {Object.values(errorlistEmpresa).map((messages, index) => (
                                                    <li key={index}>{Array.isArray(messages) ? messages[0] : messages}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    {/* Datos de la Empresa */}
                                    <div className="card">
                                        <div className="card-header">
                                            <h5 className="card-title">
                                                <i className="fas fa-building mr-2"></i>
                                                Datos de la Empresa
                                            </h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="nombreEmpresa">Nombre de la Empresa *</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="nombreEmpresa"
                                                            value={nombreEmpresa}
                                                            onChange={(e) => setNombreEmpresa(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="descripcion">Descripción</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="descripcion"
                                                            value={descripcion}
                                                            onChange={(e) => setDescripcion(e.target.value)}
                                                            placeholder="Actividad económica, giro del negocio, etc."
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <SelectorTipoDocumento
                                                        value={tipoDocumento}
                                                        onChange={setTipoDocumento}
                                                        error={errorlistEmpresa.tipo_documento?.[0]}
                                                        required={true}
                                                    />
                                                </div>
                                                <div className="col-md-8">
                                                    <CampoNit
                                                        valor={numeroDocumento}
                                                        digitoVerificacion={digitoVerificacion}
                                                        onChange={handleNitChange}
                                                        anchoValor="75"
                                                        anchoDigito="25"
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="email">Email</label>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            id="email"
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Domicilio de la Empresa */}
                                    <div className="card">
                                        <div className="card-header">
                                            <h5 className="card-title">
                                                <i className="fas fa-map-marker-alt mr-2"></i>
                                                Domicilio de la Empresa
                                            </h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="direccion">Dirección</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="direccion"
                                                            value={direccion}
                                                            onChange={(e) => setDireccion(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ciudadResidencia">Ciudad</label>
                                                        <SelectorCiudad
                                                            value={ciudadResidencia}
                                                            onChange={setCiudadResidencia}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label htmlFor="paisResidencia">País</label>
                                                        <SelectorPais
                                                            value={paisResidencia}
                                                            onChange={setPaisResidencia}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-2">
                                                    <SelectorZona
                                                        value={zona}
                                                        onChange={setZona}
                                                        error={errorlistEmpresa.zona?.[0]}
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="telefono">Teléfono</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="telefono"
                                                            value={telefono}
                                                            onChange={(e) => setTelefono(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="celular">Celular</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="celular"
                                                            value={celular}
                                                            onChange={(e) => setCelular(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-info" disabled={loadingEmpresa}>
                                        <i className="fas fa-save mr-2"></i>
                                        Guardar Empresa
                                        {loadingEmpresa && <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>}
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalCrearEmpresa(false)}>
                                        <i className="fas fa-times mr-2"></i>
                                        Cancelar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Confirmación */}
            <Modal show={showModalConfirmacion} onHide={handleCloseModalConfirmacion}>
                <Modal.Header closeButton>
                    <Modal.Title>Orden Creada Exitosamente</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>{mensajeModal}</p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalConfirmacion}>
                        No
                    </Button>
                    <Button variant="primary" onClick={handleVerDetalle}>
                        Sí, Ver Detalle
                    </Button>
                </Modal.Footer>
            </Modal>

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default CrearOrdenLaboratorio;
